export default "__VITE_ASSET__CyjVhATB__"